import { useNavigate } from 'react-router-dom';
import './style.css';
import { useResponsiveImage } from '@/utils/useResponsiveImage';

interface CardProps {
  title: string;
  tags?: React.ReactNode;
  description: string;
  author: string;
  link?: string;
  button?: React.ReactNode;
  image: {
    url: string;
    alternativeText: string;
  };
}
export default function CourseCard({ title, tags, description, author, image, link, button }: CardProps) {
  const navigate = useNavigate();
  const { src } = useResponsiveImage(image);

  return (
    <div
      key={title}
      role="button"
      tabIndex={0}
      className={`grid h-full rounded-2xl border border-primary-500 bg-white md:h-[384px] md:grid-cols-2 ${link ? 'cursor-pointer' : ' cursor-default'}`}
      onClick={() => {
        if (link) {
          navigate(link);
        }
      }}>
      <div className="overflow-hidden rounded-bl-2xl rounded-tl-2xl">
        <div
          className={`h-[384px] w-full bg-cover bg-center duration-500 ease-linear ${link ? 'group-hover:scale-110' : ''}`}
          style={{ backgroundImage: `url('${src}')` }}
        />
      </div>
      <div className="rows-span-1 flex flex-col items-start gap-1 rounded-r-2xl p-sh-30">
        {tags}
        <div>
          <p className={`font-larken text-sh-22-28 ${link ? 'group-hover:text-primary-600' : ''}`}>{title}</p>
          <p className="line-clamp-6 text-sh-xxs">{description}</p>
          {author && <p className="text-sh-xxxs text-sh-grey-500">By {author}</p>}
        </div>

        {button && <div className="rows-span-1 mt-5 flex flex-col items-start">{button}</div>}
      </div>
    </div>
  );
}
